/**
 * Coordinates initPostHog's geo+consent restore with PostHogPageview so a
 * visitor who navigates during /api/geo is not double-counted. Covered
 * pathnames skip only the in-flight restore effect; a later SPA return
 * to the mount path is a new pageview.
 */

const restoredPathnames = new Set<string>();
let settled = false;
let resolveRestored: (() => void) | undefined;
let restored = createRestoredPromise();

function createRestoredPromise(): Promise<void> {
  return new Promise<void>((resolve) => {
    resolveRestored = resolve;
  });
}

export function markInitialCaptureReady(pathname: string): void {
  restoredPathnames.add(pathname);
}

export function settleInitialCaptureReady(): void {
  if (settled) return;
  settled = true;
  resolveRestored?.();
}

export function whenInitialCaptureReady(): Promise<void> {
  return restored;
}

export function hasInitialCaptureSettled(): boolean {
  return settled;
}

export function wasInitialCapturePathname(pathname: string): boolean {
  return restoredPathnames.has(pathname);
}

/** Skip only the pageview effect that was waiting during restore, not later returns. */
export function shouldSkipInitialCapture(pathname: string, startedBeforeRestore: boolean): boolean {
  return startedBeforeRestore && restoredPathnames.has(pathname);
}

export function getInitialCapturePathname(): string | null {
  return restoredPathnames.values().next().value ?? null;
}

export function resetInitialCaptureReadyForTests(): void {
  restoredPathnames.clear();
  settled = false;
  restored = createRestoredPromise();
}
